import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_HOST;
const token = process.env.REACT_APP_JWT_SECRET;

const baseUrlV3 = "/app/v3/";

export async function getAllPLans() {
  const resp = await axios.get(`${baseUrlV3}bo/plans`);
  return resp.data;
}

export async function getAllSubscriptions() {
  const resp = await axios.get(`${baseUrlV3}plans/subscriptions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp.data;
}

export async function getOneSubscriptions(id: string) {
  const resp = await axios.get(`${baseUrlV3}plans/subscriptions/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp.data;
}
